import { render, staticRenderFns } from "./PageRecipeForm.vue?vue&type=template&id=3fa4e04e&"
import script from "./PageRecipeForm.vue?vue&type=script&lang=js&"
export * from "./PageRecipeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports